export default () => {
  const cookie = useCookie('dungeonMaster')
  return computed(() => cookie.value === 'qwerty')
}
